if (!customElements.get("sign-in-modal")) {
  customElements.define(
    "sign-in-modal",
    class SignInModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener("click", this.handleClick.bind(this));
      }

      // Close the modal for link navigations and for buttons that opt in
      // with [data-modal-close] (e.g. the "continue as guest" button).
      handleClick(event) {
        const trigger = event.target.closest("a[href], [data-modal-close]");
        if (trigger && this.contains(trigger)) {
          super.hide();
        }
      }
    }
  );
}
